import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  variant?: 'primary' | 'secondary';
  className?: string;
  ariaLabel?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  variant = 'primary',
  className = '',
  ariaLabel
}: CTAButtonProps) {
  const baseStyles = 'px-8 py-4 rounded-lg font-semibold text-lg transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-offset-2 inline-block text-center';
  const variantStyles = {
    primary: 'bg-[#C7E0E7] text-[#2C2C2C] hover:bg-[#A8C7D1] focus:ring-[#E3F2F5] shadow-lg hover:shadow-xl transform hover:-translate-y-0.5',
    secondary: 'bg-white text-[#C7E0E7] border-2 border-[#C7E0E7] hover:bg-[#FBF9F6] focus:ring-[#E3F2F5]'
  };
  const combinedClassName = `${baseStyles} ${variantStyles[variant]} ${className}`;
  if (href) {
    return <a href={href} className={combinedClassName} aria-label={ariaLabel} data-id="element-1">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={combinedClassName} aria-label={ariaLabel} data-id="element-2">
      {children}
    </button>;
}